import {
  SEND_PAYMENT_FAILED_MAIL
} from '@/store/actions.type';


export default {
  data () {
    return {
      ispaymentinfopresent: true,
    }
  },

  computed: {
    paymentinfo () {
		var paymentinfo = this.$store.state.home.paymentprocess;
		if (paymentinfo.subType === undefined)
			this.ispaymentinfopresent = false;
		else {
			var userEmail = this.$store.state.authentication.user.email;
			var name = this.$store.state.authentication.user.name;
			var paymentFailObj = {};
			paymentFailObj.userEmail = userEmail;
			paymentFailObj.name = name.charAt(0).toUpperCase() + name.slice(1);
			
			this.$store.dispatch(SEND_PAYMENT_FAILED_MAIL, paymentFailObj);
		}

		return paymentinfo;
    }
  },
  methods: {
    
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/paymentfailure.js